/*
 * Module for the Employer Account Balance Report criteria page
 */
rs.module("content/reports/employeraccountbalancecriteria",

    ["common/select-helper"],

    function (selectHelper) {

        var _jsSelectors;
        var _reportBalanceValues;
        var _filterOptionValues;
        var _contributionsCodeValueKey;
        var _criteria;

        // initialize the page
        function initialize(jsSelectors, reportBalanceValues, filterOptionValues, contributionsCodeValueKey) {

            // initialize module-scoped variables 
            _jsSelectors = jsSelectors;
            _reportBalanceValues = reportBalanceValues;
            _filterOptionValues = filterOptionValues;
            _contributionsCodeValueKey = contributionsCodeValueKey;
            _criteria = $.js(_jsSelectors.criteria);

            // Get Select Helper for receivableTypeSelect since we're updating its options and properties
            var receivableTypeSelectHelper = selectHelper.getHelper(_criteria.js(_jsSelectors.receivableTypeSelect));

            // register report balance changed event
            _criteria.js(_jsSelectors.reportbalanceSelect).change(reportBalanceChanged);

            // register report filter changed event
            _criteria.js(_jsSelectors.filterSelect).change(filterOptionChanged);

            // setup on DOM ready 
            $(filterOptionChanged);

            // Setup fields based on report balance changed
            function reportBalanceChanged() {

                switch (_criteria.js(_jsSelectors.reportbalanceSelect).val()) {

                    case _reportBalanceValues.overall:

                        // disable the receivable type select and deselect values
                        receivableTypeSelectHelper.setValue("");
                        receivableTypeSelectHelper.setDisabled(true);
                        break;

                    case _reportBalanceValues.byReceivableType:

                        // enable the receivable type select and deselect values
                        receivableTypeSelectHelper.setDisabled(false);
                        receivableTypeSelectHelper.setValue("");
                        break;

                    case _reportBalanceValues.byContributionType:

                        // disable the receivable type select and set value to the only valid option (contributions)
                        receivableTypeSelectHelper.setValue(_contributionsCodeValueKey);
                        receivableTypeSelectHelper.setDisabled(true);
                        break;

                    default:
                        return;
                }

                _criteria.js(_jsSelectors.receivableTypeSelect).clearErrors();
            }
        }

        // Setup fields based on filter option (Activity For) changed
        function filterOptionChanged() {

            // hide all filter rows
            _criteria.js(_jsSelectors.filterRow, { multiple: true }).hide();

            // show specified row
            _criteria.js(getSelectedFilterSelector()).closest(_criteria.js(_jsSelectors.filterRow, { multiple: true })).show();
        }

        // gets the selector for visible filter option
        function getSelectedFilterSelector() {

            switch (_criteria.js(_jsSelectors.filterSelect).val()) {

                case _filterOptionValues.fiscalYear:
                    return _jsSelectors.fiscalYearSelect;

                case _filterOptionValues.dateRange:
                    return _jsSelectors.fromDateTextBox;

                default:
                    return;
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);